module.exports = __webpack_public_path__ + "img/65b494ba9fe520737ed82737f2071bb0.png";